import { Card, Group, ScrollArea, Stack, TextInput, Title } from '@mantine/core'
import {
  TDownlinkPresets,
  useGetPresets,
} from 'api/loraDevices/getDownlinkPresets'
import { IconButton, Query } from 'components/common'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TbPlus, TbSearch } from 'react-icons/tb'
import { openCreateDownlinkPreset } from './CreateDownlinkPreset'
import { DownlinkPresetItem } from './DownlinkPresetItem'

export const DownlinkPresetsCard = ({
  deviceModelId,
}: {
  deviceModelId: string
}) => {
  const { t } = useTranslation()
  const query = useGetPresets(deviceModelId)

  return (
    <Card>
      <Stack>
        <Group justify="space-between">
          <Title order={4}>{t('loraDevices.chooseDownlinkPreset')}</Title>
          <IconButton
            size={'xs'}
            icon={TbPlus}
            onClick={() => openCreateDownlinkPreset(deviceModelId)}
            label={t('loraDevices.createDownlinkPreset')}
          />
        </Group>
        <Query.Wrapper query={query}>
          <Query.Data>
            {(data: TDownlinkPresets) => <PresetsList data={data} />}
          </Query.Data>
          <Query.NoData
            title={t('loraDevices.noDownlinkPresetsFound')}
            buttonContent={t('generic.add')}
            onClick={() => openCreateDownlinkPreset(deviceModelId)}
          />
        </Query.Wrapper>
      </Stack>
    </Card>
  )
}

const PresetsList = ({ data }: { data: TDownlinkPresets }) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')

  const filteredValues = useMemo(() => {
    const input = value.trim().toLowerCase()

    return input
      ? data.filter(item => item.title.toLowerCase().includes(input))
      : data
  }, [data, value])

  return (
    <Stack>
      <TextInput
        placeholder={t('generic.search')!}
        leftSection={<TbSearch size="1.2rem" />}
        value={value}
        onChange={event => setValue(event.currentTarget.value)}
      />
      <ScrollArea type="hover" h={180}>
        {filteredValues.map(item => (
          <DownlinkPresetItem key={item.id} {...item} />
        ))}
      </ScrollArea>
    </Stack>
  )
}
